export default __webpack_public_path__ + "static/media/restauran.b73bfe6f.png";